<div class="fx-trader-list fx-panel">
  <div class="card bg-dark-lighter text-white">
    <div class="card-header"></div>
    <div class="card-body">
      <div class="p-15">
        <div class="row mb-15">
          <div class="col-md-2 col-xs-12">
            <span class="text mb-1">Categories</span>
            <div class="type-group">
              <p-dropdown
                [options]="searchTypes"
                [(ngModel)]="condition.filter"
                optionValue="value"
                optionLabel="name"
                styleClass="form-control bg-dark"
                name="code"
                [autoDisplayFirst]="false"
                appendTo="body"
              ></p-dropdown>
            </div>
          </div>
          <div class="col-md-3 col-xs-12" style="padding-left: 0;">
            <span class="text mx-2"></span>
            <div class="input-group search-group">
              <input
                type="text"
                class="form-control bg-dark"
                name="keyword"
                placeholder="Search"
                [(ngModel)]="condition.keyword"
                (keyup)="search($event)"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-main"
                  type="button"
                  (click)="search('click')"
                >
                  <i class="fa fa-search" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
          <div
            class="col-md-7 col-xs-12 align-items-baseline d-flex justify-content-end"
          >
            <div>
              <div class=" d-inline-block">
                <span class="text mx-2">From
                </span>
                <div class="d-flex flex-column">
                  <p-calendar
                    name="start_time"
                    [(ngModel)]="condition.from"
                    [required]="condition.to && showError ? true : false"
                    #from="ngModel"
                    [placeholder]="'dd/mm/yyyy HH:mm:ss'"
                    [dateFormat]="'dd/mm/yy'"
                    [timeOnly]="false"
                    [showIcon]="true"
                    [showSeconds]="true"
                    [showTime]="true"
                    inputStyleClass="form-control"
                  ></p-calendar>
                <small class="error-message text-red" *ngIf="showError && (from.errors?.required)" >
                  Required
                </small>
                </div>
              </div>
              <div class="  d-inline-block ml-2" >
                <span class="text mx-2">To
                </span>
                  <div class="d-flex flex-column">
                    <p-calendar
                      name="end_time"
                      [(ngModel)]="condition.to"
                      [required]="condition.from&&showError?true:false"
                      #to="ngModel"
                      [placeholder]="'dd/mm/yyyy HH:mm:ss'"
                      [dateFormat]="'dd/mm/yy'"
                      [timeOnly]="false"
                      [showSeconds]="true"
                      [showIcon]="true"
                      [showTime]="true"
                      inputStyleClass="form-control"
                    ></p-calendar>
                    <small class="error-message text-red" *ngIf="showError && (to.errors?.required)" >
                      Required
                    </small>
                    <small class="error-message text-red" *ngIf="showError && condition.to<condition.from" >
                      To date must be later than From date
                    </small>
                  </div>
              </div>
              <br>
              <span class="fs-12" style="font-style: italic;">*Please select period to export or skip it if you want to export all data.</span>

            </div>
            <button
              class="btn btn-primary ml-2"
              pTooltip="Export Data"
              type="button"
              tooltipPosition="bottom"
              (click)="onExport()"
            >
              <i class="fa fa-download" aria-hidden="true"></i>
            </button>
            <button
              class="btn btn-main ml-2"
              pTooltip="Refresh Data"
              tooltipPosition="bottom"
              type="button"
              (click)="onRefresh()"
            >
              <i class="fa fa-refresh"></i>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-xs-12">
            <div class="table-responsive">
              <table class="rox-table table-bordered bg-dark">
                <thead>
                  <tr>
                    <th 
                      class="sortable mw-100 text-center"
                      (click)="sorting('mt5_account')"
                    >
                      MT5 Account
                      <i
                        class="fa fa-{{
                          condition.orderBy === 'mt5_account'
                            ? sort.mt5_account === 'asc'
                              ? 'sort-asc'
                              : 'sort-desc'
                            : 'sort'
                        }}"
                      ></i>
                    </th>
                    <th class="text-center">Parent IB ID</th>
                    <th
                      class="sortable mw-100 text-center"
                      (click)="sorting('username')"
                    >
                      User Name
                      <i
                        class="fa fa-{{
                          condition.orderBy === 'username'
                            ? sort.username === 'asc'
                              ? 'sort-asc'
                              : 'sort-desc'
                            : 'sort'
                        }}"
                      ></i>
                    </th>
                    <th
                      class="sortable mw-100 text-center"
                      (click)="sorting('email')"
                    >
                      Email
                      <i
                        class="fa fa-{{
                          condition.orderBy === 'email'
                            ? sort.email === 'asc'
                              ? 'sort-asc'
                              : 'sort-desc'
                            : 'sort'
                        }}"
                      ></i>
                    </th>
                    <th class="text-center">Balance</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let item of data
                        | paginate
                          : {
                              id: 'mamFollower',
                              itemsPerPage: pageInfo.pageSize,
                              currentPage: pageInfo.pageIndex,
                              totalItems: pageInfo.totalRecord
                            };
                      let i = index
                    "
                  >
                    <td class="text-center">{{ item.mt5Account }}</td>
                    <td class="text-center">
                      <a
                        href="javascript:void(0)"
                        class="text-blue-lighter {{
                          permission.allowCreating ? '' : 'ignore-click'
                        }} text-decoration-none"
                        [fxPopoverTriggerFor]="popoverIBInformation"
                        [fxPopoverData]="item.ibId"
                        >{{ item.ibId }}</a
                      >
                    </td>
                    <td class="text-center">{{ item.getUsername() }}</td>
                    <td class="text-center">{{ item.email }}</td>
                    <td class="text-center" create-permission>
                      <a
                        href="javascript:void(0)"
                        class="text-blue-lighter"
                        (click)="onViewBlance(item)"
                        >View</a
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="row mt-15">
          <div class="col">
            <div class="pagination-wrapper">
              <pagination-controls
                id="mamFollower"
                (pageChange)="pageChanged($event)"
                autoHide="true"
                responsive="true"
                previousLabel="Prev"
                nextLabel="Next"
              >
              </pagination-controls>
            </div>
          </div>
          <div class="col-auto">
            <span class="data-info"
              >Total Records: {{ pageInfo.totalRecord }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<fx-popover #popoverIBInformation (opened)="getIbInfoById($event)" [minWidth]="'400px'">
  <ng-template fxPopoverContent let-data="data">
    <h3>IB Information</h3>
    <table class="rox-table table-bordered bg-dark">
      <tbody>
        <tr *ngFor="let item of selectedIbInfor; let i = index">
          <td>Email: {{ item.email }}</td>
        </tr>
      </tbody>
    </table>
  </ng-template>
</fx-popover>

<p-sidebar 
  [(visible)]="isShowAccountBlance" 
  [baseZIndex]="1050"
  class="sidebar-blance"
  position="right" 
  styleClass="page-content">
  <fx-trader-balance [data]="selectedItem"></fx-trader-balance>
</p-sidebar>
